import React, { useEffect, useRef, useState } from 'react';
import useInView from '../../hooks/useInView';
import { shouldAnimate } from '../../utils/motion';

/**
 * Terminal that types its lines while on screen and loops.
 * The full output is rendered first, so static HTML and reduced motion
 * always show the complete text.
 */
export default function TypingTerminal({ title, lines }) {
  const ref = useRef(null);
  const inView = useInView(ref);
  const [typed, setTyped] = useState(null);

  useEffect(() => {
    if (!inView || !shouldAnimate()) return undefined;

    let timer = 0;
    let line = 0;
    let char = 0;
    const output = [];

    const step = () => {
      if (line >= lines.length) {
        timer = window.setTimeout(() => {
          line = 0;
          char = 0;
          output.length = 0;
          setTyped([]);
          timer = window.setTimeout(step, 300);
        }, 4500);
        return;
      }
      const text = lines[line].text;
      if (char < text.length) {
        char += 1;
        output[line] = text.slice(0, char);
        setTyped([...output]);
        timer = window.setTimeout(step, line === 0 ? 45 : 16);
      } else {
        line += 1;
        char = 0;
        timer = window.setTimeout(step, 380);
      }
    };

    setTyped([]);
    timer = window.setTimeout(step, 300);
    return () => {
      window.clearTimeout(timer);
      setTyped(null);
    };
  }, [inView, lines]);

  const isTyping = Array.isArray(typed);
  const visible = isTyping ? lines.slice(0, Math.max(typed.length, 0)) : lines;

  return (
    <div className="home-terminal" ref={ref}>
      <div className="home-terminal-bar" aria-hidden="true">
        <i />
        <i />
        <i />
        <span>{title}</span>
      </div>
      <pre aria-label={lines.map((item) => item.text).join('. ')}>
        {visible.map((item, index) => (
          <span key={item.text} className={`home-terminal-${item.tone}`} aria-hidden="true">
            {isTyping ? typed[index] : item.text}
            {index < visible.length - 1 ? '\n' : ''}
          </span>
        ))}
        {isTyping && <span className="home-terminal-caret" aria-hidden="true" />}
      </pre>
    </div>
  );
}
